import React, { useMemo, useRef } from "react";
import FormControl from "@mui/material/FormControl";
import { Grid } from "@mui/material";
import { InputField } from "../../../../../library/custom/textBox/InputField";
import FormLabels from "../../../../../library/custom/formLabel/FormLabels";
import SearchAutoComplete from "../../../../../library/custom/searchAutoComplete/SearchAutoComplete";
import SelectMenu from "../../../../../library/custom/selectMenu/SelectMenu";
import {
  HBNEXT_ORG_ID,
  LOGIN_ORG_ID,
  ORG_ID,
} from "../../../../../constant/constant";
import { NumberField } from "../../../../../library/custom/numberField/numberField";
import { sortAlphabetically } from "../../../../../utils/helper";

const SwIndividualCommonForm = (props) => {
  const { propsData, InspectionType, frequency } = props;

  const autoComp = useRef(null);

  const sortedFrequency = useMemo(() => {
    return sortAlphabetically(frequency);
  }, [frequency]);

  const sortedInspectionQuestionSetList = useMemo(() => {
    return sortAlphabetically(propsData?.inspectionQuestionSetList);
  }, [propsData?.inspectionQuestionSetList]);

  return (
    <>
      <Grid item md={6} xs={12}>
        {ORG_ID() !== LOGIN_ORG_ID() ? (
          <FormControl fullWidth>
            <FormLabels label="Client" isRequired={false} />
            <InputField
              isRequired={false}
              type="text"
              placeholder={"Add Client Name Here..."}
              value={propsData?.clients?.value}
              disabled={ORG_ID() !== 1}
            />
          </FormControl>
        ) : (
          <FormControl fullWidth>
            <FormLabels label="Client Name" isRequired={true} />
            <SearchAutoComplete
              name="Add Individual Users"
              optionsData={propsData?.allClients ?? []}
              typeOnchange={(event, value) =>
                propsData?.searchClient(event, value)
              }
              isKeyValuePair={true}
              value={propsData?.clients}
              onChange={(e, value) => propsData?.onChangeClients(value)}
              isLoading={propsData?.isSearchClientLoading}
              autoCompClear={autoComp}
              noOptionsTextMsg={"No Client Name"}
              disabled={parseInt(LOGIN_ORG_ID()) !== parseInt(HBNEXT_ORG_ID)}
            />
          </FormControl>
        )}
        {propsData?.firstClientError && !propsData?.clients && (
          <p className="error">First select client</p>
        )}
      </Grid>
      {propsData?.clients !== null && (
        <Grid item md={6} xs={12}>
          <FormControl fullWidth>
            <FormLabels label="Project" isRequired={true} />
            <SearchAutoComplete
              name="Add Individual Users"
              optionsData={propsData?.allProjects ?? []}
              typeOnchange={(event, value) =>
                propsData?.handleAllProjectSearch(event, value)
              }
              isKeyValuePair={true}
              value={propsData?.projects}
              onChange={(e, value) => propsData?.onChangeProjects(value)}
              isLoading={propsData?.isProjectLoading}
              autoCompClear={autoComp}
              noOptionsTextMsg={"No Project"}
            />
          </FormControl>
        </Grid>
      )}

      {propsData?.projects && (
        <Grid item md={6} xs={12}>
          <FormControl fullWidth>
            <FormLabels label="Inspection Type" isRequired={true} />
            <SelectMenu
              placeholder="Please Select"
              listData={InspectionType ?? []} // temporary base change
              // listData={getSwReference?.insTypeMstList ?? []}
              value={
                propsData?.inspectionTypeId ? propsData?.inspectionTypeId : null
              }
              onchangehandler={(e) =>
                propsData?.handleInspectionTypeSetChange(e)
              }
              disabled={propsData?.editMode}
            />
          </FormControl>
        </Grid>
      )}

      {propsData?.projects &&
        propsData?.inspectionTypeId !== null &&
        (propsData?.inspectionTypeId === 1 ||
          propsData?.inspectionTypeId === 3) && (
          <Grid lg={6} xs={12} sm={6} md={6} item>
            <FormControl fullWidth>
              <FormLabels label="Frequency" isRequired={true} />
              <SelectMenu
                placeholder="Please Select"
                listData={sortedFrequency ?? []}
                value={
                  propsData?.frequencyValue ? propsData?.frequencyValue : null
                }
                onchangehandler={(e) => propsData?.handleFrequencyChange(e)}
                disabled={propsData?.disabledCheck()}
              />
            </FormControl>
            {propsData?.frequencyValueError && !propsData?.frequencyValue && (
              <p className="error">Frequency is required</p>
            )}
          </Grid>
        )}

      {propsData?.projects && parseInt(propsData?.frequencyValue) === 7 && (
        <Grid item lg={6} xs={12} sm={12} md={6}>
          <FormControl fullWidth={true}>
            <NumberField
              disabled={false}
              isRequired={true}
              type="text"
              label={"Date Range"}
              maxLength="3"
              value={propsData?.frequencyInDays}
              placeholder={"Enter Frequency In Days..."}
              onChange={(value) => propsData?.dateRangeHandler(value)}
            />
          </FormControl>
          {propsData?.dateRangeError && (
            <p className="error">Number should be between 1 to 365</p>
          )}
          {propsData?.errorFrequencyInDays && (
            <p className="error">Please add frequencyInDays </p>
          )}
        </Grid>
      )}

      {propsData?.projects &&
        propsData?.inspectionTypeId &&
        propsData?.inspectionTypeId !== null && (
          <Grid item md={6} xs={12}>
            <FormControl fullWidth>
              <FormLabels label="Inspection Name" isRequired={true} />
              <SelectMenu
                placeholder="Inspection Name"
                listData={sortedInspectionQuestionSetList}
                value={
                  propsData?.questionSetId ? propsData?.questionSetId : null
                }
                onchangehandler={(e) => propsData?.handleQuestionSetChange(e)}
              />
            </FormControl>
          </Grid>
        )}
    </>
  );
};

export default SwIndividualCommonForm;
